/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Validation_Contact_Id_DuplicateInputs */

const en_case_validation_contact_id_duplicate = /** @type {(inputs: Case_Validation_Contact_Id_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each contact must have a unique identifier.`)
};

const pt_br2_case_validation_contact_id_duplicate = /** @type {(inputs: Case_Validation_Contact_Id_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada contato deve ter um identificador único.`)
};

/**
* | output |
* | --- |
* | "Each contact must have a unique identifier." |
*
* @param {Case_Validation_Contact_Id_DuplicateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_contact_id_duplicate = /** @type {((inputs?: Case_Validation_Contact_Id_DuplicateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_Contact_Id_DuplicateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_contact_id_duplicate(inputs)
	return pt_br2_case_validation_contact_id_duplicate(inputs)
});